import { FC } from 'react';
import { Avatar } from 'components/Avatar';
import classNames from 'classnames';
import styles from './InfoEmployeds.module.scss';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { enumerate } from 'utils/strActions';
import { getFormatPhone } from 'utils/getFotmatPhone';
import { BannerErrorEmployeds } from 'components/BannerErrorEmployeds';

type InfoEmployedsProps = {
  name: string;
  surname: string;
  patronymic?: string;
  phone?: string;
  inn?: string;
  id: number;
  avatar: string | null;
  status?: number;
  withPhoneIcon?: boolean;
  nationality?: string;
  compact?: boolean;
  isDeleted?: boolean;
  birthdate?: string;
  textContractBanner?: string;
};

export const InfoEmployeds: FC<InfoEmployedsProps> = ({
  id,
  avatar,
  name = 'Исполнитель',
  surname = 'Неизвестный',
  patronymic,
  phone,
  inn,
  nationality,
  compact = false,
  isDeleted,
  birthdate = '',
  textContractBanner = '',
}) => {
  const role = localStorage.getItem('role');
  const isWorkSupport = role === 'worksupport';
  let content = '';

  const birthDate = new Date(birthdate);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  if (surname && name) {
    content = `${surname} ${name}`;
  }
  if (surname && name && patronymic) {
    content = `${surname} ${name} ${patronymic}`;
  }

  return (
    <div className={styles.root}>
      <Avatar
        name={name}
        surname={surname}
        avatar={avatar}
        id={id}
        statusActive={''}
        isDeleted={isDeleted}
      />
      <div className={styles.text} style={{ gap: compact ? 0 : '4px' }}>
        <div className={styles.name}>
          <div className={styles.name_textWrap}>
            <TextWithTooltip content={content} className={classNames(styles.name_text)} />
          </div>
          {birthdate && (
            <span className={styles.age}>
              {`, ${age} ${enumerate(age, ['год', 'года', 'лет'])}`}
            </span>
          )}
        </div>
        {(phone || (isDeleted && isWorkSupport) || nationality || textContractBanner) && (
          <div
            className={styles.phone}
            style={{ padding: isWorkSupport ? '0 16px' : undefined }}>
            {phone && (
              <TextWithTooltip
                content={getFormatPhone(phone) || ''}
                className={styles.phoneText}
              />
            )}
            {phone && nationality && <span className={styles.metaDot}></span>}
            {nationality && (
              <TextWithTooltip content={nationality} className={styles.nationality} />
            )}
            {textContractBanner && <BannerErrorEmployeds content={textContractBanner} />}
          </div>
        )}
        {inn && <TextWithTooltip content={`ИНН ${inn}`} className={styles.inn} />}
      </div>
    </div>
  );
};
